<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList?.isExchangeRate" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
          ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <v-card class="tw-p-4  tw-m-2 tw-rounded-lg tw-min-h-70">
          <v-row class="tw-px-6 tw-pt-8">
            <v-col class="pa-0">
              <h3 class="tw-text-lg">Exchange Rate</h3>
            </v-col>
            <v-col class="pa-0" cols="3">
              <!-- date picker for column podate  -->
              <v-menu
                v-model="isOpenTodayDatePicker"
                :close-on-content-click="true"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="292px"
                min-width="292px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="เลือกวันที่"
                    append-icon="mdi-calendar-month-outline"
                    readonly
                    :value="dateDsp"
                    outlined
                    class="ma-0 pa-0"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  locale="en-in"
                  v-model="dateSearch"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-tabs v-model="currentBankTabIndex">
            <v-row>
              <v-tab v-for="(item, index) in companyBankList" :key="index">
                <img
                  :src="item.bankLogoUrl"
                  alt=""
                  srcset=""
                  class="tw-h-6 tw-w-6 tw-mr-2 tw-rounded-full"
                />
                {{ item.bankCode }}
              </v-tab>
            </v-row>
            <v-tab-item v-for="(item, index) in companyBankList" :key="index">
              <div class="table-container tw-mt-4">
                <table border="1" cellpadding="5" cellspacing="0">
                  <thead>
                    <tr v-if="getBankColumn(item.bankCode)?.length > 0">
                      <th
                        :class="`${getBankBg(
                          item.bankCode
                        )} tw-text-center tw-rounded-tl-lg tw-w-1/${
                          getBankColumn(item.bankCode)?.length + 1
                        }`"
                        rowspan="2"
                      >
                        Currency
                      </th>
                      <th
                        :colspan="
                          getBankColumn(item.bankCode, 'BUYING')?.length
                        "
                        :class="`${getBankBg(
                          item.bankCode
                        )}  tw-text-center tw-border-l tw-border-r tw-border-b tw-border-white tw-w-${
                          getBankColumn(item.bankCode, 'BUYING')?.length
                        }/${getBankColumn(item.bankCode)?.length + 1}`"
                      >
                        BUYING
                      </th>
                      <th
                        :colspan="
                          getBankColumn(item.bankCode, 'SELLING')?.length
                        "
                        :class="`${getBankBg(
                          item.bankCode
                        )} tw-rounded-tr-lg   tw-text-center tw-border-b tw-border-white tw-w-${
                          getBankColumn(item.bankCode, 'SELLING')?.length
                        }/${getBankColumn(item.bankCode)?.length + 1}`"
                      >
                        SELLING
                      </th>
                    </tr>
                    <tr>
                      <th
                        v-for="(colItem, colIndex) in getBankColumn(
                          item.bankCode,
                          'BUYING'
                        )"
                        :key="'b_' + colIndex"
                        :class="`${getBankBg(
                          item.bankCode
                        )}  tw-border-l tw-border-white tw-text-center tw-w-1/${
                          getBankColumn(item.bankCode)?.length + 1
                        }`"
                      >
                        {{ colItem?.colName }}
                      </th>
                      <th
                        v-for="(colItem, colIndex) in getBankColumn(
                          item.bankCode,
                          'SELLING'
                        )"
                        :key="'s_' + colIndex"
                        :class="`${getBankBg(
                          item.bankCode
                        )} tw-text-center tw-border-l tw-border-white tw-w-1/${
                          getBankColumn(item.bankCode)?.length + 1
                        }`"
                      >
                        {{ colItem?.colName }}
                      </th>
                    </tr>
                  </thead>
                </table>
                <div class="detail-table tw-transform tw--translate-y-8">
                  <table>
                    <tbody v-if="sortedExchangeRates?.length !== 0">
                      <tr
                        v-for="(rate, currency, index) in sortedExchangeRates"
                        :key="currency"
                        :class="index % 2 !== 0 ? 'tr-gray' : 'tr-gray-low'"
                      >
                        <td
                          :class="`tw-w-1/${
                            getBankColumn(item.bankCode)?.length + 1
                          }  tw-mr-1`"
                        >
                          <div class="tw-flex tw-gap-1">
                            <img
                              :src="getImageFlagImageUrl(currency)"
                              alt=""
                              class="tw-w-10 tw-mr-2 tw-object-contain"
                            />
                            <div class="tw-flex tw-flex-col">
                              <span
                                style="font-size: 0.7rem; font-weight: bold"
                                >{{ currency }}</span
                              >
                              <span style="font-size: 0.6rem">{{
                                getCountryFullName(currency)
                              }}</span>
                            </div>
                          </div>
                        </td>
                        <td
                          v-for="(colItem, colIndex) in getBankColumn(
                            item.bankCode,
                            'BUYING'
                          )"
                          :key="'rb_' + colIndex"
                          :class="`tw-w-1/${
                            getBankColumn(item.bankCode)?.length + 1
                          }  ${
                            colItem?.active && 'tw-font-bold'
                          } tw-text-center ${
                            colIndex == 0 && 'tw-border-l tw-border-gray'
                          } ${
                            colIndex ==
                              getBankColumn(item.bankCode, 'BUYING').length -
                                1 && 'tw-border-r tw-border-gray'
                          }`"
                        >
                          {{ rate?.[colItem?.fieldName] || "-" }}
                        </td>
                        <td
                          v-for="(colItem, colIndex) in getBankColumn(
                            item.bankCode,
                            'SELLING'
                          )"
                          :key="'rs_' + colIndex"
                          :class="`tw-w-1/${
                            getBankColumn(item.bankCode)?.length + 1
                          } ${
                            colItem?.active && 'tw-font-bold'
                          }  tw-text-center`"
                        >
                          {{ rate?.[colItem?.fieldName] || "-" }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="5" class="tw-py-16">
                          <div
                            class="tw-flex tw-flex-col tw-items-center tw-justify-center"
                          >
                            <p
                              class="tw-text-xl tw-font-semibold tw-text-gray-500"
                            >
                              No exchange rates data found
                            </p>
                            <p class="tw-text-sm tw-text-gray-400 tw-mt-2">
                              Please try again later or contact support if the
                              problem persists.
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="sortedExchangeRates?.length !== 0" class="tw-flex tw-justify-between">
                  <span class="tw-my-2 tw-ml-1 tw-opacity-70">
                    <span class="tw-text-red">*</span> Update on <b> {{ getTodayDate() }} {{ getCurrentHour() }}:00</b>
                  </span>
                  <span class="tw-my-2 tw-ml-1 tw-opacity-70">
                    [Unit :
                    <span class="tw-text-red">{{
                      currentBank.bankCode === "BCEL" ? "Kip" : "Baht"
                    }}</span>
                    per <span class="tw-text-red">1</span> unit of foreign
                    currency]
                  </span>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapState } from "vuex";
import getCountryFlagBaseUrl from "@/libs/getCountryFlagBaseUrl";
import getCountryName from "@/libs/getCountryName";
import logActivity from "@/libs/activityLogger";
const _ = require("lodash");

export default {
  data() {
    const today = new Date();
    const todayISO = today.toISOString().substr(0, 10);

    return {
      currentBankTabIndex: 0,
      companyBankList: [
        {
          bankName: "Bank of Thailand",
          bankCode: "BOT",
          bankLogoUrl:
            "/images/banks/bot.png",
        },
        {
          bankName: "KasikornBank",
          bankCode: "KBANK",
          bankLogoUrl:
          "/images/banks/kbank.png",
        },
        {
          bankName: "Siam Commercial Bank",
          bankCode: "SCB",
          bankLogoUrl:
          "/images/banks/scb.png",
        },

        {
          bankName: "Bangkok Bank",
          bankCode: "BBL",
          bankLogoUrl:
          "/images/banks/bbl.png",
        },
        {
          bankName: "Krungthai Bank",
          bankCode: "KTB",
          bankLogoUrl:
          "/images/banks/ktb.png",
        },
        {
          bankName: "United Overseas Bank Limited",
          bankCode: "UOB",
          bankLogoUrl: "/images/banks/uob.png",
        },
        {
          bankName: "Banque Pour Le Commerce Exterieur Lao Public",
          bankCode: "BCEL",
          bankLogoUrl: "/images/banks/bcel.png",
        },
      ],
      currentBank: {},
      exchangeRates: {},
      exChangeUnsubscribe: null, // Listener to unsubscribe from Firestore updates
      dateSearch: todayISO,
      dateDsp: "",
      isOpenTodayDatePicker: false,
    };
  },
  name: "exchangeRate",
  components: {
    Admin,
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    getTodayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    getCurrentHour() {
      const now = new Date();
      now.setMinutes(0, 0, 0); // Set minutes and seconds to 00:00
      return now.getHours()
    },
    getYesterdayDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    async fetchExchangeRate() {
      // /ExchangeRateCenter/FX-Rate/KBANK/2024-03-09
      this.exchangeRates = [];

      const currentSelectedBankCode = this.currentBank?.bankCode;
      console.log("currentSelectedBankCode", currentSelectedBankCode);

      const exchangeRateDocRef = fc.db
        .collection(`ExchangeRateCenter/FX-Rate/${currentSelectedBankCode}`)
        .doc(this.dateDsp);

      try {
        if (this.exChangeUnsubscribe) {
          this.exChangeUnsubscribe();
        }
        this.exChangeUnsubscribe = exchangeRateDocRef.onSnapshot((snapshot) => {
          let resultExchangeRate = snapshot.data();
          delete resultExchangeRate?.timeCreate;
          this.exchangeRates = resultExchangeRate;
        });
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
      }
    },
    getImageFlagImageUrl(currencyCode) {
      return getCountryFlagBaseUrl(currencyCode);
    },
    getCountryFullName(currencyCode) {
      return getCountryName(currencyCode);
    },
    getBankBg(bankCode) {
      let bgColor = "bot-bg";
      switch (bankCode) {
        case "BOT":
          bgColor = "bot-bg";
          break;
        case "KBANK":
          bgColor = "kbank-bg";
          break;
        case "BBL":
          bgColor = "bbl-bg";
          break;
        case "KTB":
          bgColor = "ktb-bg";
          break;
        case "SCB":
          bgColor = "scb-bg";
          break;
        case "BCEL":
          bgColor = "bcel-bg";
          break;
        case "UOB":
          bgColor = "uob-bg";
          break;
        default:
          break;
      }
      return bgColor;
    },
    getBankColumn(bankCode, _type) {
      let bankColumn = [];
      switch (bankCode) {
        case "BOT":
          bankColumn = [
            {
              colName: "Sight Bill",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "Transfer",
              fieldName: "BuyingTRN",
              type: "BUYING",
              active: true,
            },
            {
              colName: "Average Selling Rates",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        case "KBANK":
          bankColumn = [
            {
              colName: "TRAVELLERS' CHEQUES",
              fieldName: "BuyingCHQ",
              type: "BUYING",
            },
            {
              colName: "EXPORT SIGHT BILL",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "TELEX TRANSFER",
              fieldName: "BuyingTRN",
              type: "BUYING",
            },
            {
              colName: "BANK NOTES",
              fieldName: "BuyingNotes",
              type: "BUYING",
              active: true,
            },
            {
              colName: "TT&DRAFT T/CHEQUES",
              fieldName: "SellingCHQ",
              type: "SELLING",
            },
            {
              colName: "BANK NOTES",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        case "BBL":
          bankColumn = [
            {
              colName: "Sight Bill",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "TT",
              fieldName: "BuyingTRN",
              type: "BUYING",
            },
            {
              colName: "Bank Notes",
              fieldName: "BuyingNotes",
              type: "BUYING",
              active: true,
            },
            {
              colName: "Bill - DD - TT",
              fieldName: "SellingCHQ",
              type: "SELLING",
            },
            {
              colName: "Bank Notes",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        case "KTB":
          bankColumn = [
            {
              colName: "SIGHT BILL",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "TT",
              fieldName: "BuyingTRN",
              type: "BUYING",
            },
            {
              colName: "FOREIGN BANK NOTE",
              fieldName: "BuyingNotes",
              type: "BUYING",
              active: true,
            },

            {
              colName: "T/T",
              fieldName: "SellingCHQ",
              type: "SELLING",
            },
            {
              colName: "FOREIGN BANK NOTE",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        case "SCB":
          bankColumn = [
            {
              colName: "T/CHQS. & CHQS.",
              fieldName: "BuyingCHQ",
              type: "BUYING",
            },
            {
              colName: "EXPORT SIGHT BILL",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "TT",
              fieldName: "BuyingTRN",
              type: "BUYING",
            },
            {
              colName: "NOTE",
              fieldName: "BuyingNotes",
              type: "BUYING",
              active: true,
            },

            {
              colName: "D/D & T/T",
              fieldName: "SellingCHQ",
              type: "SELLING",
            },
            {
              colName: "NOTE",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        case "BCEL":
          bankColumn = [
            {
              colName: "BILL",
              fieldName: "BuyingEXP",
              type: "BUYING",
            },
            {
              colName: "EFT",
              fieldName: "BuyingTRN",
              type: "BUYING",
            },
            {
              colName: "NOTE",
              fieldName: "BuyingNotes",
              type: "BUYING",
              active: true,
            },
            {
              colName: "Sell Rates",
              fieldName: "SellingNotes",
              type: "SELLING",
              active: true,
            },
          ];
          break;
        default:
          break;
      }

      return _type === "ALL" || !_type
        ? bankColumn
        : bankColumn?.filter((item) => item.type === _type);
    },
  },
  computed: mapState({
    selectedCompanyProductList: (state) =>
      state.companies.selectedCompanyProductList,
    isProductListLoading: (state) => state.companies.isProductListLoading,
    sortedExchangeRates() {
      if (!this.exchangeRates) return [];
      return Object.entries(this.exchangeRates)
        .sort(([a], [b]) => a.localeCompare(b))
        .reduce((acc, [currency, rate]) => {
          acc[currency] = rate;
          return acc;
        }, {});
    },
  }),
  watch: {
    currentBankTabIndex(newVal) {
      this.currentBank = this.companyBankList[newVal];
      this.fetchExchangeRate();
    },
    dateSearch(val) {
      this.dateDsp = this.formatDate(val);
    },
    dateDsp(newVal) {
      this.fetchExchangeRate();
    },
  },
  mounted() {
    logActivity('page_view', { page_title: 'ExchangeRate' })
    this.currentBank = this.companyBankList[this.currentBankTabIndex];
    this.dateDsp = this.formatDate(this.dateSearch);
  },
  beforeDestroy() {
    // Unsubscribe from Firestore updates when component is destroyed
    if (this.exChangeUnsubscribe) {
      this.exChangeUnsubscribe();
    }
  },
};
</script>

<style lang="css" scoped>
.table-container {
  padding: 1rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

.tr-gray {
  background-color: hsla(0, 0%, 62%, 0.149);
}

.tr-gray-low {
  background-color: hsla(0, 0%, 79%, 0.094);
}

.bot-bg {
  background-color: #133265;
}

.kbank-bg {
  background-color: #00a94f;
}

.ktb-bg {
  background-color: #01a6e6;
}

.bcel-bg {
  background-color: #ec1c24;
}

.bbl-bg {
  background-color: #0065fe;
}

.scb-bg {
  background-color: #4e2a82;
}
.uob-bg {
  background-color: #05377b;
}

.detail-table {
  /* border: 2px solid red; */
  height: 60vh;
  overflow-y: auto;
  /* Scrollbar customization */
  /* scrollbar-width: 5px; */
}

/* For WebKit browsers (Chrome, Safari, etc.) */
.detail-table::-webkit-scrollbar {
  width: 3px;
}

.detail-table::-webkit-scrollbar-track {
  background: rgba(231, 231, 231, 0.5);
}

.detail-table::-webkit-scrollbar-thumb {
  background-color: rgb(133, 133, 133);
  border-radius: 20px;
  border: transparent;
}

.table-container table {
  width: 100%;
  margin-bottom: 2rem;
}

.table-container th {
  padding: 8px 5px;
  text-align: left;
  color: #fff;
}

/* Styling for table cells */
.table-container td {
  padding: 10px;
  height: 60px;
}
</style>
